<template>
  <section class="quote-payment page-container">
    <h2>{{ isEndorse? 'Buy Quote': 'Payment' }}</h2>

    <div class="main-contain">
      <div>
        <div class="content">
          <h2>Online Payment</h2>
          <new-payment-form
            :detail="form"
            :customerId="formData.customer_id"
            :customerName="formData.customer? formData.customer.isrd_nm: ''"
            :orderId="orderId"
            :amount="amountResult"
            :haveCredit="isEndorse? true: false"
            :transactionFee="getTransactionFee"
            :getCredit="getCredit"
            @success="paymentSuccess"
            @handlerBlur="handlerBlur"
            @change-credit="handlerChangeCredit"
          />

          <!--          <send-link-->
          <!--            :orderId="orderId"-->
          <!--            :customerId="formData.customer_id"-->
          <!--            :quote_no="formData.quotation_number"-->
          <!--          ></send-link>-->
        </div>
      </div>


      <div>
        <div  v-if="!isEndorse">
          <!--          <v-button @click="() => $router.back()">Previous</v-button>-->
          <v-button @click="handlerPre">Previous</v-button>
        </div>
        <div  v-if="!isEndorse">
          <div class="company-logo">
            <img
              v-if="formData.company_logo"
              :src="formData.company_logo"
              alt="company"
            />
            <span class="label">{{ formData.plan }}</span>
          </div>
          <div class="flex-content">

            <div class="flex-box">
              <div
                v-for="(item, index) in sidebarPremium"
                :key="index"
                class="flex-info">
                <span>{{ item.item }}</span>
                <span>{{ item.premium | formatMoney(2, true) }}</span>
              </div>
              <div
                v-if="getCredit"
                class="flex-info ">
                <span>Credit Point</span>
                <span class="amount">-{{ getCredit| formatMoney(2, true) }}</span>
              </div>
              <div
                v-if="getTransactionFee"
                class="flex-info transa-color">
                <span>Transaction Fee</span>
                <span>+{{getTransactionFee| formatMoney(2, true) }}</span>
              </div>

              <div
                class="flex-info total-amount">
                <span>Total Payable</span>
                <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
              </div>
            </div>
            <code-select
              v-if="formData.use_code!=0"
              :orderId="orderId"
              :notApply="true"
              :isQuote="false"
              :customerId="formData.customer_id"
              :customer="formData.customer"
              :isSpon="isSpon"
              :useCode="formData.use_code"
              :is-user="true"
              @check-code="applyCode"
            ></code-select>
          </div>
        </div>

        <div
          v-if="isEndorse"
          class="">
          <span class="endorse-title">Endorsement</span>
          <div class="company-logo">
            <img
              :src="formData.company_logo"
              alt="company"
            />
            <span class="label">{{ formData.plan }}</span>
          </div>
          <div class="flex-content">

            <div class="flex-box">
              <div
                v-for="(item, index) in sidebarPremium"
                :key="index"
                class="flex-info">
                <span>{{ item.item }}</span>
                <span>{{ item.premium | formatMoney(2, true) }}</span>
              </div>
              <div
                v-if="getCredit"
                class="flex-info ">
                <span>Credit Point</span>
                <span class="amount">-{{ getCredit| formatMoney(2, true) }}</span>
              </div>
              <div
                v-if="getTransactionFee"
                class="flex-info transa-color">
                <span>Transaction Fee</span>
                <span>+{{getTransactionFee| formatMoney(2, true) }}</span>
              </div>
              <div
                class="flex-info total-amount">
                <span>Total</span>
                <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </section>
</template>
<script>
import newPaymentForm from '@/views/components/newPaymentForm'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import {changeEndorsementStatus} from '@/api/endorsement'
import {applyOrderCode, verifyPromoCode} from '@/api/order'
import CodeSelect from '@/views/components/code-select'
// import { referApplyCode } from '@/api/refer'
export default {
  name: 'QuotePayment',
  components: {
    newPaymentForm,
    CodeSelect
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({
        customer: {
          isrd_nm: ''
        }
      })
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: [String],
      default: 'refer'
    },
    policyModifyId: {
      type: [String, Number],
      default: ''
    },
    isRenew:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      // lastAmount: '',
      code:'',
      getCredit: 0,
      getTransactionFee: 0,
      credit:'',
      codeData: {},
      coupon:'',
      updateCoupon:false
    }
  },
  computed: {
    ...mapState('ticket', ['refreshPage']),
    ...mapState('coupon', ['couponCode','selectCode']),
    isSMEProduct(){
      let {product_id} = this.form
      return product_id==80
    },
    isEndorse() {
      return this.type === 'endorsement'? true: false
    },
    amountResult() {
      const { amount = '' } = this.codeData
      return amount !== ''? Number(amount): Number(this.formData.amount)
    },
    customerId() {
      return this.formData.customer_id
    },
    premium_info(){
      let {premium_info=[]} = this.form.sidebar_info||{}
      return premium_info||[]
    },
    sidebarPremium() {
      // if(!this.formData.quote_coverage_list) {
      //   return []
      // }
      let coverageList
      if(this.isSMEProduct){
        coverageList =this.premium_info
      }else {
        let {sidebar_premium} = this.formData.quote_coverage_list||{}
        coverageList = sidebar_premium||[]
      }
      if(!coverageList) {
        return []
      }
      return coverageList.filter(item => item.name != 'paid')
    },
    isSpon(){
      let { quote_coverage_list} = this.formData||{}
      let {plan_info={}} =quote_coverage_list||{}
      let {is_sponsor=''} = plan_info||{}
      return is_sponsor==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.formData = JSON.parse(JSON.stringify(val))
          // this.lastAmount = [30, 40, 50].includes(Number(val.type))? val.undo_endorse_amount: val.amount
          // this.code = val.code
          this.updateCoupon = false
          if(this.isEndorse) {
            // this.network().applyOrderCode()
          }
          else {
            const { quo_id } = val
            if(quo_id) {
              this.network().applyOrderCode()
            }
          }

        }

      }
    },
  },
  methods: {
    ...mapActions('ticket', ['setRefreshPage']),
    ...mapActions('coupon', ['setCouponData','setSelectCode']),
    handlerBlur(credit){
      this.credit = credit

      if(credit != this.getCredit)
        this.network().applyOrderCode()
    },
    handlerPre(){
      this.$emit('pre')
    },
    handlerCoupon(){
      this.$refs['coupon-dialog'].changeDialog()
    },
    applyCode(){
      // if (!this.code) {
      //   this.$message({
      //     type: 'warning',
      //     message: '請輸入優惠碼'
      //   })
      //   return
      // }
      this.updateCoupon = true
      this.network().applyOrderCode()
    },
    computedCoupon(data){
      this.coupon = data
      this.formData.coupon = data
      this.updateCoupon = true
      this.network().applyOrderCode({
        updateCredit: false
      })
    },
    onSendSignature() {
      this.checking = true
      setTimeout(() => {
        this.checkedVerify = true
      }, 1000)
    },
    paymentSuccess() {
      // this.$message({
      //   type: 'success',
      //   message: '支付成功了呢，接下來去哪裏呢'
      // })
      // if(this.isEndorse) {
      //   // 需要調用更改狀態接口
      //   this.network().changeEndorsementStatus()
      // }
      // else {
      // 刷新 detail 頁
      setTimeout(()=>{
        this.setRefreshPage(this.refreshPage+1)
      },300)
      // }

    },
    handlerChangeCredit(credit) {
      // let amount = OMath.round(this.formData.amount) - OMath.round(val)
      // amount = OMath.round(amount)
      // this.lastAmount = amount
      this.credit = credit
      this.network().applyOrderCode({
        updateCredit: false
      })
    },
    network() {
      return {
        changeEndorsementStatus: async () => {
          const { data } = await changeEndorsementStatus({
            stts: 301,
            id: this.policyModifyId
          })
          // 刷新 detail 頁
          this.setRefreshPage(this.refreshPage+1)
        },
        verifyPromoCode: async () => {
          const { data } = await verifyPromoCode({
            customer_id: this.customerId,
            code: this.code
          })
          if(data.code == 1000) {
            this.network().applyOrderCode()
            // if(this.notApply) {
            //   this.$emit('check-code', this.code)
            // } else {
            // if(this.codeType == 'refer') {
            //   // refer 單
            //   this.network().referApplyCode()
            // } else {
            //   // 正常單
            //   this.network().applyOrderCode()
            // }
            // }
          }
        },
        applyOrderCode: async ({ updateCredit = true } = {}) => {
          if(this.isRenew) return
          let {selectCode, code, coupon} = this.selectCode||{}
          let select = JSON.parse(JSON.stringify(this.selectCode||{}))
          let params = {}
          let {campaign_code} = this.form||{}
          params.campaign_code = campaign_code
          if(coupon&&coupon.selectCode==1)params.coupon_code = coupon&&coupon.coupon_code
          if(code&&code.selectCode==2)params.code = code&&code.code
          const { data } = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customerId,
            // code: this.code,  // endorse 沒有優惠碼
            credit:this.credit,
            // coupon:this.coupon.coupon_code||''
            ...params
          })
          if(campaign_code)
          {
            select.code= {selectCode: 2, code:campaign_code}
            select.is_campaign_code = 1
          }
          this.setSelectCode(select)
          this.codeData = data

          let { credit, transaction_fee, amount	,coupon_vl} = data

          if(updateCredit) {
            this.getCredit = credit
          }
          this.getTransactionFee = transaction_fee
          // 判斷是否需要更新 detail 數據
          if(this.updateCoupon) this.$emit('apply')
          // this.$emit('apply', {
          //   ...data,
          //   code: this.code
          // })
          //   this.formData.amount = data.amount
        },
        // referApplyCode: async () => {
        //   const { data } = await referApplyCode({
        //     order_id: this.orderId,
        //     code: this.code
        //   })
        //   this.$message({
        //     type: 'success',
        //     message: 'Success'
        //   })
        //   let { credit, transaction_fee, amount	} = data
        //   this.getCredit = credit
        //   this.getTransactionFee = transaction_fee
        // }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  position: relative;
  min-width: 1150px;
  //padding: 0 88px;
  h1{
    color: #24292E;
    font-size: 20px;
    padding-left: 88px;
    border-bottom: 1px solid #E1E4E8;
  }
  h2{
    color: #24292E;
    font-size: 16px;
  }
  .main-contain {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 0 88px;
    justify-content: space-between;
    >div{
      width: 50%;
      .content{
        padding: 31px 0;
      }
      .content-border{
        margin-top: 20px;
        //border-bottom: 1px solid #E1E4E8;
        border-top: 1px solid #E1E4E8;
      }
    }
    >div:last-child{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 31px 0;
    }
    .send-container {
      margin-right: 15px;
      width: 450px;
    }
    .payment-container {
      width: 450px;
      .verify-container {
        & > span:first-child {
          display: block;
          padding-bottom: 15px;
          font-size: 16px;
          color: #616266;
        }
        .verify-next {
          padding-top: 15px;
          .waiting {
            display: block;
            padding-bottom: 10px;
            color: #616266;
            font-size: 16px;
            span {
              display: inline-block;
              padding-left: 5px;
            }
          }
        }
      }
    }
  }
  .company-logo {
    margin-top: 31px;
    display: flex;
    width: 280px;
    img {
      // width: 100%;
      //height: 100%;
      margin-right: 26px;
      margin-left: 11px;
      height: 51px;
    }
  }
  .flex-content {
    width: 280px;
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      width: 280px;
      margin: 16px 0;

      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #E1E4E8;

        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight: 500;
        }

        span:last-child {
          color: #24292E;
          font-size: 14px;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
    }
  }


  .right {
    margin-left: 15px;
    min-width: 200px;
    max-width: 200px;

    .label {
      display: block;
      margin: 10px 0;
      font-size: 16px;
      line-height: 19px;
      font-weight: bold;
    }
    .total-box {
      margin: 15px -15px -15px -15px;
      padding: 15px;
      background: #ECF5FF;
      span {
        display: block;
        color: #616266;
        font-size: 14px;
      }
      .amount {
        font-size: 24px;
        color: #409eff;
        font-weight: bold;
      }
    }
  }
  .coupon-button{
    .el-button{
      width: 100%;
    }
    .margin-right{
      margin-right: 10px;
    }
  }
  .coupon-data{
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    padding: 16px;
    .coupon-title{
      color: #24292E;
      font-size: 16px;
      font-weight: 600;
      text-overflow: ellipsis;
      word-break: break-word;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .coupon-des{
      text-overflow: ellipsis;
      word-break: break-word;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      margin-top: 8px;
      font-size: 12px;
      -webkit-box-orient: vertical;
      color: #586069;
    }
  }
}

</style>
